import React, { useState } from 'react'
import { withRouter } from 'react-router'
import { Icon, NavBar } from 'antd-mobile'
import { History } from 'history'
import './search-header.less'

// 处理IOS Webview上拉时
const touchmoveHandle = (e: any) => {
  e.preventDefault()
}

interface Props {
  history?: History
  onSearch: string
}
const SearchHeader = ({ history, onSearch, change, onClear }: Props & any) => {
  const [key, setKey] = useState('')
  const onKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      onSearch(key)
    }
  }
  change && change(setKey)

  return (
    <NavBar
      mode="light"
      icon={<Icon type="left" />}
      onLeftClick={() => {
        if (key) {
          setKey('')
          onClear && onClear()
        } else {
          history.goBack()
          setTimeout(() => {
            if (/^\/search$/.test(history.location.pathname)) {
              try {
                if (window.WebViewBridge) {
                  window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
                } else if (window.webkit) {
                  window.webkit.messageHandlers.navBackMarket.postMessage('')
                }
              } catch (e) {

              }
            }
          })
        }
      }}
      rightContent={
        <span className="font-7 search-btn" onClick={() => onSearch(key)}>
          搜索
        </span>
      }
    >
      <span className="search-input">
        <img src="/public/assets/img/search.png" alt="" />
        <input
          onFocus={() => {
            document.body.addEventListener('touchmove', touchmoveHandle, {
              passive: false,
            })
          }}
          onBlur={() => {
            document.body.removeEventListener('touchmove', touchmoveHandle)
          }}
          value={key}
          onChange={({ target }: any) => setKey(target.value)}
          type="search"
          onKeyPress={onKeyPress}
        />
        <span
          className={`input-clear ${key ? 'dis-block' : ''}`}
          onClick={() => {
            setKey('')
            onClear && onClear()
          }}
        />
      </span>
    </NavBar>
  )
}
export default withRouter(SearchHeader)
